import { fromJS } from 'immutable'

import * as loadActions from './LoadAlertAction'

export const loadAlertInitialState = fromJS({
	isLoading: false,
	loadAlerts: null,
	loadAlert: null,
	sortCriteria: {
		by: 'CreationDate',
		ascending: false,
	},
	page: 0,
	rowsPerPage: 20,
	searchQuery: '',
	loadCount: null,
	isSaving: false,
	identifier: '',
})

export default function loadReducer(state = loadAlertInitialState, action) {
	switch (action.type) {
		case loadActions.SET_LOAD_ALERT_LIST: {
			let loadAlertsList = fromJS(action.loadAlerts)
			return state.merge({
				loadAlerts: loadAlertsList,
				isLoadingShippings: false,
			})
		}
		case loadActions.SET_LOAD_ALERT: {
			let loadAlertList = fromJS(action.loadAlert)
			return state.merge({
				loadAlert: loadAlertList,
				isLoadingShippings: false,
			})
		}
		case loadActions.IS_SAVING: {
			return state.merge({
				isSaving: action.isSaving,
				identifier: action.identifier,
			})
		}
		case loadActions.SET_LOAD_ALERT_COUNT: {
			return state.merge({
				loadCount: action.count,
			})
		}
		case loadActions.START_LOADING_LOAD_ALERTS: {
			return state.merge({
				isLoading: action.isLoading,
			})
		}
		case loadActions.CHANGE_LOAD_ALERT_QUERY: {
			return state.merge({
				searchQuery: action.query,
				page: 0,
				rowsPerPage: state.rowsPerPage,
			})
		}
		case loadActions.CHANGE_LOAD_ALERTS_PAGINATION: {
			return state.merge({
				page: action.page,
				rowsPerPage: action.rowsPerPage,
			})
		}
		case loadActions.ADD_FILES_LOAD_ALERT: {
			let oldList = state.getIn(['loadAlert', action.listItems]).toJS()
			let filesToAdda = action.files.filter((newFileSupl) => {
				return !oldList.find((uploadedFile) => {
					return uploadedFile.name === newFileSupl.name
				})
			})
			let newList = [...oldList, ...filesToAdda]
			return state.setIn(['loadAlert', action.listItems], fromJS(newList))
		}
		default:
			return state
	}
}
